import Papa from "papaparse";
import { RenderToast } from "./HelperFunction";

export async function ProductCsvToJsonConversion(
  data,
  fn,
  header = true,
  skipEmptyLines = true
) {
  Papa.parse(data, {
    header: header,
    skipEmptyLines: skipEmptyLines,
    complete: function (results) {
      if (!results?.data?.length) {
        return RenderToast({
          type: "error",
          message: "No data found in csv",
        });
      } else {
        const keys = results?.meta?.fields;
        const delimiter = results?.meta?.delimiter;
        const returnObj = { keys, delimiter, data: results?.data };
        fn(returnObj);
      }
    },
  });
}
